import { apiClient } from './client';

export interface BenefitRulesEffectiveRules {
  benefits: Record<string, unknown>;
  fieldBounds: Record<string, unknown>;
}

export interface ShopBenefitRulesResponse {
  template_key: string;
  template_rules: Record<string, unknown>;
  rules_patch: Record<string, unknown> | null;
  effective_rules: BenefitRulesEffectiveRules;
}

export function getBenefitRules (shopId: number | string) {
  return apiClient.get<ShopBenefitRulesResponse>(`/${shopId}/benefit-rules`);
}

export function saveBenefitRulesOverride (
  shopId: number | string,
  rulesPatch: Record<string, unknown> | null,
) {
  return apiClient.put<ShopBenefitRulesResponse>(`/${shopId}/benefit-rules-override`, {
    rules_patch: rulesPatch,
  });
}
